import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateConfig } from '@core/config/date.config';

@Pipe({
    name: 'dateTimeFormat',
    standalone: false
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  public transform(value: any): any {
    return super.transform(value, DateConfig.DATE_TIME_FORMAT);
  }
}
